export default "__VITE_PUBLIC_ASSET__321ee6ba__"